import React from "react"

export const Icon = React.forwardRef(
  ({ iconClass, size = "1rem", onClick, secondaryClass }, ref) => {
    const styles = {
      height: size,
      width: size,
    }

    return (
      <>
        <i
          className={`Icon ${iconClass ? iconClass : ""} ${
            secondaryClass ? secondaryClass : ""
          }`}
          style={styles}
          ref={ref}
          onClick={
            onClick
              ? onClick
              : () => {
                  return null
                }
          }
        ></i>
      </>
    )
  }
)
